// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"f5408bd58778a2ee2952","339":"dcbb4a112d0621488d8f"}[chunkId] + ".js";
};